import type { ChildrenProp } from "@charterindex/armoury-www";
import { forwardRef } from "react";
import { Link } from "react-router";


const getHref = (input: string): string => {
	const url = new URL(window.location.href);

	if(input.startsWith("#")) {
		url.hash = input;
	} else if(input.startsWith("?")) {
		url.search = input;
	} else {
		if(url.pathname !== input) {
			url.search = "";
			url.hash = "";
		}

		url.pathname = input.split("?")[0]!;
		if(input.includes("?")) {
			url.search = input.split("?")[1] ?? "";
		}
	}

	return [
		url.pathname,
		url.search || "",
		url.hash || "",
	].join("");
};

type LinkWrapperProps = ChildrenProp & { href: string };
export const LinkWrapper = forwardRef<HTMLAnchorElement, LinkWrapperProps>(({ href, children, ...props }, ref) => {
	return (
		<Link
			to={ getHref(href) }
			ref={ ref }
			{ ...props }
		>
			{ children }
		</Link>
	);
});
